import { useQuery, useQueryClient } from 'react-query';
import { axios } from 'lib';

export const getOpportunity = (id) => {
  return axios.get(`/opportunities/${id}`);
};

export const useOpportunity = (opporunityId) => {
  const queryClient = useQueryClient();
  const cachedQuery = queryClient.getQueriesData(['opportunities', opporunityId]);

  const concatQueries = cachedQuery.reduce((accumulator, currentQuery) => {
    const flattenedData = currentQuery.at(-1)?.pages.reduce((r, obj) => {
      return r.concat(obj.data);
    }, []);

    if (typeof flattenedData !== 'undefined') {
      flattenedData.forEach((datum) => {
        const found = accumulator.find((innerDatum) => innerDatum.id === datum.id);
        if (!found) accumulator.push(datum);
      });
    }

    return accumulator;
  }, []);

  return useQuery(['opportunity', opporunityId], () => getOpportunity(opporunityId), {
    initialData: () => concatQueries?.find((datum) => datum.id === opporunityId),
    staleTime: 60 * 1000,
    initialDataUpdatedAt: () => queryClient.getQueryState()?.dataUpdatedAt,
  });
};
